import { useState, useEffect } from 'react'; 
import logo from './logo.svg';
import faunadb, { query as q } from 'faunadb'; 
import Rating from 'react-rating'; 
import { useCookies } from 'react-cookie'; 
import { v4 as uuidv4 } from 'uuid'; 
import ReactGA from 'react-ga'; 
import './App.css';
import PineappleNoFill from './pineapple-nofill.svg'; 
import PineappleFill from './pineapple-fill.svg'; 

import AddQuoteForm from './AddQuoteForm'; 
import AdminLogin from './AdminLogin'; 
import AdminPanel from './AdminPanel'; 
import { root } from 'postcss';

function App() {
  const [quotes, setQuotes] = useState([]); 
  // const [unrated, setUnrated] = useState([]); // checked={unrated[indexKey] ? true : false} 
  const [lastRatings, setLastRatings] = useState([]); 
  const [cookies, setCookies] = useCookies(['guid']); 
  const [cookiesPermission, setCookiesPermission] = useState(false); 
  const [showAskCookies, setShowAskCookies] = useState(false); 
  const [mobileAddQuoteBtn, setMobileAddQuoteButton] = useState(true); 
  const [adminPass, setAdminPass] = useState(''); 
  const [showAdminPass, setShowAdminPass] = useState(false); 
  const [adminMode, setAdminMode] = useState(false); 

  useEffect(async () => {
    // let res = (await (await (await fetch("/quotes.txt")).text()).split('---')); 
    // res.forEach(str => str.replace(/(\r\n|\n|\r)/gm, "")); 
    // setQuotes(res); 
    // quotes.map(quote => {
    //  setTimeout(() => addQuote(quote), 1000); 
    // }); 
    // addQuote("SOME PROFOUND STATEMENT"); 
    let allDocs = await db_client.query(q.Map(
      q.Paginate(q.Documents(q.Collection('quotes'))),
      q.Lambda(x => q.Get(x))
    )); 
    setQuotes(allDocs.data); 
    if (!cookies.guid) {
      setCookiesPermission(false); 
      setShowAskCookies(true); 
      console.log("Cookies not set."); 
    } else {
      setCookiesPermission(true); 
      setShowAskCookies(false); 
      setLastRatings(cookies.lastRatings); 
      console.log("GUID set!"); 
      console.log("Last ratings saved!"); 
    }
    // (!cookies.guid) ? setCookies('guid', uuidv4(), { path: '/' }) : console.log("GUID set!"); 
    // (!cookies.lastRatings) ? setCookies('lastRatings', JSON.stringify(allDocs.data.map(() => 0)), { path: '/' }) : console.log("Last ratings saved!"); 

    console.log(lastRatings); 
    console.log(allDocs); 

    ReactGA.pageview(window.location.pathname); 
    console.log(window.location.pathname); 
    // cookies.get('guid'); 
    // updateRating(quotes[0].ref, 5); 

    let rootDiv = document.getElementById("root"); 
    rootDiv.addEventListener("scroll", () => {
      // console.log("hellooooo!", rootDiv.scrollHeight, rootDiv.scrollTop+window.innerHeight);
      let scrollY = rootDiv.scrollTop+window.innerHeight; 
      if (scrollY > rootDiv.scrollHeight-100 && mobileAddQuoteBtn) {
        setMobileAddQuoteButton(false); 
        // console.log(mobileAddQuoteBtn, "off"); 
      } else {
        setMobileAddQuoteButton(true); 
        // console.log(mobileAddQuoteBtn, "on"); 
      }
    }); 
  }, []); 

  
  const db_client = new faunadb.Client({
    secret: process.env.REACT_APP_DB_KEY, 
    domain: "db.us.fauna.com", 
    port: 443,
    scheme: 'https', 
  }); 

  const updateRating = async (ref, rating) => {
    // retrieve existing document with id... 
    let newDoc; 
    await db_client.query(
      q.Get(ref) 
    ).then(ret => { newDoc = ret; console.log(ret, rating) }); 
    newDoc.data.ratings[cookies.guid] = rating; 
    newDoc.data.ratingAvg = Object.values(newDoc.data.ratings).reduce((a, b) => a + b, 0) / Object.values(newDoc.data.ratings).length; 
    console.log("DOC: ", newDoc); 
    // let existing_post; 

    db_client.query(
      q.Update(
        ref, 
        { data: newDoc.data }
      ) 
    ).then(ret => console.log(ret)); 
  }; 
  
  const handleRating = (val, quote, index) => {
    if (!cookiesPermission) {
      setShowAskCookies(true); 
      return; 
    }
    // * add a setTimeout that cancels/resets if a new rating comes in before it runs out 
    // if (unrated[index]) { // ! to make all ratings start at 0, not working; all start at 5! 
    //   let newUnrated = unrated; 
    //   newUnrated[index] = false; 
    //   setUnrated(newUnrated); 
    //   console.log("NEW RATING!", unrated); 
    // } 
    let newLastRating = lastRatings; 
    newLastRating[index] = val; 
    setLastRatings(newLastRating); 
    setTimeout(() => {
      if (lastRatings[index] === val) {
        ReactGA.event({
          category: 'Content',
          action: 'Rated a Quote',
          value: val
        });
        console.log("MATCHED!", lastRatings); 
        updateRating(quote.ref, val); 
        setCookies('lastRatings', JSON.stringify(lastRatings), { path: '/' }); 
        console.log("DATATE EAE:", cookies); 
      }
    }, 1500); 
    // ratingTimer = setTimeout(() => updateRating(quote.ref, e.target.dataset.val), 5000); 
    // console.log("TYPE: ", typeof ratingTimer, "VALUE: ", ratingTimer); 
    // setTimeout(() => ratingTimer ? ratingTimer.clearTimeout() : console.log(typeof ratingTimer, ratingTimer), 6000); 
  }; 

  const handleCookies = (e, val) => {
    if (val) {
      setCookies('guid', uuidv4(), { path: '/' }); 
      setCookies('lastRatings', JSON.stringify(quotes.map(() => 0)), { path: '/' }); 
      setCookiesPermission(true); 
    } else {
      setCookiesPermission(false); 
    }
    setShowAskCookies(false); 
  }; 

  const handleAdminLogin = e => {
    e.preventDefault(); 
    if (adminPass === process.env.REACT_APP_ADMIN_PASSWORD) {
      setAdminMode(true); 
      setAdminPass(''); 
      console.log("ADMIN MODE ON"); 
    } 
  }; 

  
  // console.log(quotes); 
  return (
    <div className="flex flex-col relative"> 
    {
      (showAskCookies) ? (
        <div class="alert bg-base-300 shadow-lg fixed bottom-5 left-7 right-7 m-0 w-auto z-10">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Cookies are used to ensure the validity of voting data.</span>
          </div>
          <div class="flex-none">
            <button class="btn btn-sm btn-ghost" onClick={e => handleCookies(e, false)}>Deny</button>
            <button class="btn btn-sm btn-primary" onClick={e => handleCookies(e, true)}>Accept</button>
          </div>
        </div>
      ) : ""}
      <div className="relative">
        {/* <div className="alert alert-warning shadow-lg w-5/6 md:w-1/4 ml-5 mt-5 top-0 left-0 absolute">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p>Rating system on the way!</p>
          </div>
        </div>   */}
        <div className="text-5xl font-extrabold text-center m-5 mt-10 OFFmt-20 OFFmd:mt-10">
          <img src={PineappleFill} className="w-1/2 md:w-1/4 h-auto mx-auto my-5 inline" /> 
          <h1>HiznyQuotes</h1>
          {/* <img src={pineapple} className="w-20 h-20 mx-auto inline" />  */}
        </div>
      </div>
      <div className="divider w-1/2 mx-auto mb-5"></div> 
      <p className="mx-7 lg:mx-auto italic bg-warning bg-opacity-50 border-2 border-yellow-200 rounded -skew-x-3 p-2 my-5"><span className="font-bold">Disclaimer:</span> Mr. Hizny is a history teacher. The quotes on this page are taken from the context of the history lessons he teaches.</p> 
      <div className="m-2 md:flex">
        <div className="p-10 border-2 border-gray-500 rounded-lg mx-5"> 
          <ul> 
            {quotes.map((quote, indexKey) => (
              <div key={indexKey}>
                {quote.data ? (
                  <div className="flex items-start">
                    <Rating emptySymbol={<div className="w-7" style={{content: `url(${PineappleNoFill})`}} />} fullSymbol={<div className="w-7" style={{content: `url(${PineappleFill})`}} />} fractions={2} initialRating={quote.data.ratingAvg} readonly /> 
                    <p className="ml-4 italic">{Object.keys(quote.data.ratings).length} rating{(Object.keys(quote.data.ratings).length==1) ? "" : "s"}</p>
                  </div> 
                ) : "No ratings..."} 
                <li className="italic pt-1 pb-2">{quote.data ? quote.data.quote : "Loading..."}</li> 
                <div className="flex items-start">
                  <p className="text-sm">Your rating: </p>
                  <Rating className="scale-95 hover:scale-105 transition-transform ml-3 mb-10" emptySymbol={<div className="w-5" style={{content: `url(${PineappleNoFill})`}} />} fullSymbol={<div className="w-5" style={{content: `url(${PineappleFill})`}} />} fractions={2} initialRating={lastRatings[indexKey]} onChange={val => handleRating(val, quote, indexKey)} /> 
                </div>
              </div>
            ))}
          </ul>
        </div>
        {cookiesPermission && (
          <div className={`fixed float-right bottom-5 right-5 md:hidden z-10 ${!mobileAddQuoteBtn && "hidden"}`}>
            <button className="btn btn-lg btn-circle btn-primary">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
              </svg> 
            </button> 
          </div>
        )} 
        <div className="hidden md:block h-auto">
          <div className="sticky top-5">
            <p className="mx-2 text-3xl font-bold">Add a Quote</p>
            <p className="mx-2 text-sm text-gray-500 font-semibold">
              Don't see a quote you added?
              <div className="ml-2 dropdown dropdown-left">
                <label tabIndex={0} className="btn btn-circle btn-ghost btn-xs text-info">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="w-4 h-4 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg> 
                </label> 
                <div tabIndex={0} className="card card-compact dropdown-content shadow bg-neutral rounded-box w-64">
                  <div className="card-body text-white font-normal">
                    <p>All quotes must be approved by Mr. Hizny before they show up on the page. If you don't see your quote, it's probably because it hasn't been approved yet, or it was rejected. </p>
                  </div>
                </div>
              </div> 
            </p>
            <div className="mt-5 p-5 border-2 border-primary rounded-lg">
              <AddQuoteForm cookies={cookies} cookiesPermission={cookiesPermission} setShowAskCookies={setShowAskCookies} db_client={db_client} /> 
            </div>
          </div>
        </div>
      </div>
      <footer className="footer flex justify-between items-center mx-auto mt-5 p-5 w-11/12 bg-base-300 shadow-xl rounded-t-xl">
        <p className="inline-block gap-1 text-sm md:text-base">
          Made with 
          <svg xmlns="http://www.w3.org/2000/svg" className="inline m-1 p-0 h-5 w-5 text-primary scale-95 hover:scale-110 transition-transform" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
          </svg> 
          by 
          <a href="https://github.com/Lathryx/" target="_blank" className="inline-block m-1 text-primary scale-95 hover:scale-110 transition-transform">Lathryx</a> 
          and 
          <a href="https://github.com/sayofthelor" target="_blank" className="inline-block m-1 text-primary scale-95 hover:scale-110 transition-transform">sayofthelor</a> 
        </p>
        
        {/* <div className="ml-auto dropdown dropdown-left dropdown-end">
          <label tabIndex={0} className="p-1 h-14 w-14 btn btn- btn-secondary">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
              <path fillRule="evenodd" d="M12.516 2.17a.75.75 0 00-1.032 0 11.209 11.209 0 01-7.877 3.08.75.75 0 00-.722.515A12.74 12.74 0 002.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 00.374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 00-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08zm3.094 8.016a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
            </svg>
          </label>
          <div tabIndex={0} className="mr-3 dropdown-content card card-compact w-64 p-2 bg-neutral shadow-lg">
            <div className="card-body">
              <p className="card-title">Admin Login</p> 

            </div>
          </div>
        </div> */}

        { adminMode ? <AdminPanel className="ml-auto" db_client={db_client} setAdminMode={setAdminMode} /> : <AdminLogin className="ml-auto" setAdminMode={setAdminMode} />} 

        <a href="https://github.com/Lathryx/HiznyQuotes" target="_blank" className="btn btn-ghost h-14 w-auto p-1">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full" x="0px" y="0px"
            width="64" height="64"
            viewBox="0 0 64 64"
            fill="currentColor"><path d="M32 6C17.641 6 6 17.641 6 32c0 12.277 8.512 22.56 19.955 25.286-.592-.141-1.179-.299-1.755-.479V50.85c0 0-.975.325-2.275.325-3.637 0-5.148-3.245-5.525-4.875-.229-.993-.827-1.934-1.469-2.509-.767-.684-1.126-.686-1.131-.92-.01-.491.658-.471.975-.471 1.625 0 2.857 1.729 3.429 2.623 1.417 2.207 2.938 2.577 3.721 2.577.975 0 1.817-.146 2.397-.426.268-1.888 1.108-3.57 2.478-4.774-6.097-1.219-10.4-4.716-10.4-10.4 0-2.928 1.175-5.619 3.133-7.792C19.333 23.641 19 22.494 19 20.625c0-1.235.086-2.751.65-4.225 0 0 3.708.026 7.205 3.338C28.469 19.268 30.196 19 32 19s3.531.268 5.145.738c3.497-3.312 7.205-3.338 7.205-3.338.567 1.474.65 2.99.65 4.225 0 2.015-.268 3.19-.432 3.697C46.466 26.475 47.6 29.124 47.6 32c0 5.684-4.303 9.181-10.4 10.4 1.628 1.43 2.6 3.513 2.6 5.85v8.557c-.576.181-1.162.338-1.755.479C49.488 54.56 58 44.277 58 32 58 17.641 46.359 6 32 6zM33.813 57.93C33.214 57.972 32.61 58 32 58 32.61 58 33.213 57.971 33.813 57.93zM37.786 57.346c-1.164.265-2.357.451-3.575.554C35.429 57.797 36.622 57.61 37.786 57.346zM32 58c-.61 0-1.214-.028-1.813-.07C30.787 57.971 31.39 58 32 58zM29.788 57.9c-1.217-.103-2.411-.289-3.574-.554C27.378 57.61 28.571 57.797 29.788 57.9z"></path></svg>
        </a>
      </footer>
    </div>
  );
}

export default App;
